
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/12v-trolling-motor-battery-wearable-solar-charger",
      function () {
        return require("private-next-pages/12v-trolling-motor-battery-wearable-solar-charger/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/12v-trolling-motor-battery-wearable-solar-charger"])
      });
    }
  